import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { inject } from "@angular/core";
import { UsersService } from "../services/users.service";
import { take } from "rxjs/operators";
import { BusinessService } from "../services/business.service";

export const paymentApplicationIdGuard = async (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    const businessService = inject(BusinessService);
    const router = inject(Router);
    const id = route.paramMap.get('businessId')!;
    const currentBusiness = await businessService.selectedBusiness$.pipe(take(1)).toPromise();
    console.log(id);
    console.log(currentBusiness);
    if(currentBusiness?.businessId === id)
        return router.createUrlTree(['/payment-application']);

    const businesses = await businessService.availableBusinesses$.pipe(take(1)).toPromise();
    console.log(businesses);
    if(!businesses.find(business => business.businessId === id))
        return router.createUrlTree(['/lobby']);

    await businessService.selectBusiness(id, false);

    return router.createUrlTree(['/payment-application']);
};